import { Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from './ProtectedRoute';
import LoginRegister from "../LoginRegister/LoginRegister"
import ChatHistory from "../App/ChatHistory"
import ImpressumPage from "../Impressum/ImpressumPage"
import TermsAndPrivacyPage from "../TermsAndPrivacy/TermsAndPrivacyPage"
import { PaymentSuccessPage, PaymentCancelPage } from '../NewPages/PaymentReturnPages';
import { CancelSubscriptionPage } from '../NewPages/CancelSubscriptionPage';

import { BootstrapWorkflows } from '../NewPages/BootstrapWorkflows';
import { BootstrapAnalytics } from '../NewPages/BootstrapAnalytics';
import { BootstrapInterfaceBuilder } from '../NewPages/BootstrapInterfaceBuilder';
import { BootstrapSettings } from '../NewPages/BootstrapSettings';
import { BillingPage } from '../NewPages/BillingPage';
import MarketPlace from '../Marketplace/MarketPlace';
import { CategoryAppsPage } from '../Apps/CategoryAppsPage';

import { WorkflowEditorPageWithLoading } from '../../components/LazyComponents';
import { isFeatureEnabled } from '../../features';
import ImageGeneration from '../App/ImageGeneration';
import VideoGeneration from '../App/VideoGeneration';
import DocumentToPDF from '../App/OcrTool';
import VisionModel from '../App/VisionModel';
import ImageToGifGeneration from '../App/ImageToGifGeneration';
import ImageToVideoGeneration from '../App/ImageToVideoGeneration';
import PromptChecker from '../App/PromptChecker';
import SEOCheckerApp from '../App/SEOChecker';
import RagBot from '../App/RagBot';
import SpeechToText from '../App/SpeechToText';
import ImageToImageEdit from '../App/ImageToImageEdit';
import ImageToImageInPaint from '../App/ImageToImageInPaint';
import ImageStudio from '../App/ImageStudio';
import { isAppRouteAllowed } from '../../data/appRegistry';

// Direktaufruf einer per appRegistry.ts (maxStage) ausgeblendeten App -> Startseite. Laufzeit-Guard:
// die Seiten-Chunks bleiben im Bundle (nichts Geheimes), nur die Erreichbarkeit entfaellt.
const guardApp = (route: string, element: JSX.Element) =>
  isAppRouteAllowed(route) ? <ProtectedRoute>{element}</ProtectedRoute> : <Navigate to="/chat" replace />;


export const PageRoutes = () => {
  return (
    <Routes>
      {/* Auth */}
      <Route path='/login' element={<LoginRegister />} />
      <Route path='/' element={<Navigate to="/chat" replace />} />

      {/* Default app */}
      <Route path='/chat' element={<ProtectedRoute><ChatHistory /></ProtectedRoute>} />

      {/* App categories */}
      <Route path='/apps/:category' element={<ProtectedRoute><CategoryAppsPage /></ProtectedRoute>} />

      {/* Individual apps (keep existing routes for direct linking) */}
      <Route path="/executions/1" element={<Navigate to="/chat" replace />} />
      <Route path="/executions/2" element={guardApp('/executions/2', <ImageGeneration />)} />
      <Route path="/executions/3" element={guardApp('/executions/3', <VideoGeneration />)} />
      <Route path="/executions/4" element={guardApp('/executions/4', <DocumentToPDF />)} />
      <Route path="/executions/5" element={guardApp('/executions/5', <VisionModel />)} />
      <Route path="/executions/6" element={guardApp('/executions/6', <ImageToGifGeneration />)} />
      <Route path="/executions/7" element={guardApp('/executions/7', <ImageToVideoGeneration />)} />
      <Route path="/executions/8" element={guardApp('/executions/8', <PromptChecker />)} />
      <Route path="/executions/9" element={guardApp('/executions/9', <SEOCheckerApp />)} />
      <Route path="/executions/10" element={guardApp('/executions/10', <RagBot />)} />
      <Route path="/executions/11" element={guardApp('/executions/11', <SpeechToText />)} />
      <Route path="/executions/12" element={guardApp('/executions/12', <ImageToImageEdit />)} />
      <Route path="/executions/13" element={guardApp('/executions/13', <ImageToImageInPaint />)} />
      <Route path="/executions/14" element={guardApp('/executions/14', <ImageStudio />)} />
      <Route path="/executions" element={<Navigate to="/apps/knowledge" replace />} />

      {/* Platform pages */}
      <Route path="/dashboard" element={<Navigate to="/analytics" replace />} />
      <Route path="/analytics" element={<ProtectedRoute><BootstrapAnalytics /></ProtectedRoute>} />
      {/* Demo-Zustand mit Mock-Daten, nicht produktionsreif (siehe TASKS.md, Feature-Switch-System) -
          derzeit ohnehin von keiner Sidebar/App-Kachel aus verlinkt, Route bleibt fuer Direktlinks
          bestehen, leitet aber auf Umgebungen ohne Freigabe weg. */}
      <Route path="/workflows" element={isFeatureEnabled('workflowBuilder') ? <ProtectedRoute><BootstrapWorkflows /></ProtectedRoute> : <Navigate to="/chat" replace />} />
      <Route path="/workflows/:id" element={isFeatureEnabled('workflowBuilder') ? <ProtectedRoute><WorkflowEditorPageWithLoading /></ProtectedRoute> : <Navigate to="/chat" replace />} />
      <Route path="/workflows/new" element={isFeatureEnabled('workflowBuilder') ? <ProtectedRoute><WorkflowEditorPageWithLoading /></ProtectedRoute> : <Navigate to="/chat" replace />} />
      <Route path="/interface-builder" element={<ProtectedRoute><BootstrapInterfaceBuilder /></ProtectedRoute>} />
      <Route path="/marketplace" element={<ProtectedRoute><MarketPlace /></ProtectedRoute>} />
      <Route path="/store" element={<Navigate to="/marketplace" replace />} />
      <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancelPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><BootstrapSettings /></ProtectedRoute>} />

      {/* Legal */}
      <Route path='/impressum' element={<ImpressumPage />} />
      <Route path='/terms' element={<TermsAndPrivacyPage />} />
      {/* § 312k BGB: muss OHNE Login erreichbar sein - kein ProtectedRoute! */}
      <Route path='/kuendigung' element={<CancelSubscriptionPage />} />
      <Route path='/subscription' element={<Navigate to="/billing" replace />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
